import { REJECT_MESSAGE_EVENT } from '../Insights/InsightsWindow';


export class PackageRouter {

    disconnectedModal;

    constructor(socketHandler) {
        this.socketHandler = socketHandler;
        this.app = this.socketHandler.api.parent;
        this.messageQueue = [];
        this.receivedMessageCounter = 0;
    }

    route = (messageEvent) => {
        if (this.disconnectedModal) {
            this.disconnectedModal.dispose();
        }

        let receivedMessage = JSON.parse(messageEvent.data);

        let messageType = receivedMessage.type;
        const queuedTypes = [
            'Message', 'Game', 'GamePlayer',
            'Campaign', 'Choice', 'Sound',
            'Event', 'Transcript'
        ]
        // console.log('PackageRouter.route', receivedMessage.type);
        if (queuedTypes.includes(messageType)) {
            this.queueMessage(receivedMessage);
        } else {
            this.processMessage(receivedMessage);
        }
    }

    isQueueBlocked = () => {
        let blocked = false;
        if (this.app.gameController && this.app.gameController.game && this.app.gameController.game.operations) {
            blocked |= this.app.gameController.game.operations.isThereAnEventInProgress();
        }
        return blocked;
    }

    queueMessage = (receivedMessage) => {
        // console.log('PackageRouter.queueMessage', this.messageQueue.map(({ type }) => type));
        const gc = this.app && this.app.gameController;
        if (gc && gc.gameEnded) return;
        this.messageQueue.push(receivedMessage);
        this.processQueue();
    }

    processQueue = () => {
        // console.log('PackageRouter.processQueue', this.messageQueue.map(({ type }) => type));
        if (!this.isQueueBlocked()) {
            let nextMessage = this.messageQueue.shift();
            if (nextMessage) this.processMessage(nextMessage);
        } else {
            console.log('PackageRouter.Queue is blocked.', this.messageQueue.map(({ type }) => type))
        }
    }

    messageProcessingComplete = () => {
        // console.log('messageProcessingComplete', this.messageQueue.map(({ type }) => type));
        if (this.messageQueue.length > 0) this.processQueue();
    }

    processMessage = (receivedMessage) => {
        // Late post-EOG Patch messages would otherwise wake the
        // tradelane river and re-animate orbits after the game ended.
        // Patch arrives via the non-queued path so it bypasses
        // queueMessage's gate; check explicitly here.
        const gc = this.app && this.app.gameController;
        if (gc && gc.gameEnded && receivedMessage.type === 'Patch') {
            return;
        }
        ++this.receivedMessageCounter;
        const trackingId = this.receivedMessageCounter;
        // Phase 0.5 (2026-04-11): temporary diagnostic — mirrors the
        // outbound log in SocketHandler/API so we can see both halves
        // of the WS conversation in the browser console. Remove once
        // the group/members race is proven fixed.
        console.log('API.received', receivedMessage.type,
                    receivedMessage.package && receivedMessage.package.type,
                    receivedMessage);
        switch (receivedMessage.type) {
            case 'Message':
                window.dispatchEvent(new CustomEvent('message-event', { detail: receivedMessage.package.message }));
                this.processQueue();
                break;
            case 'List':
                this.listMessage(receivedMessage);
                break;
            case 'Create':
                this.gameMessage(receivedMessage);
                break;
            case 'Game':
                this.gameMessage(receivedMessage);
                this.processQueue();
                break;
            case 'GamePlayer': {
                // The per-seat push now carries the Game-level shared
                // pools (lodging/bed/amenity/action) that the seat's
                // action just mutated. Apply that pool signal FIRST so
                // gameData is current before the seat update fans out —
                // the client-side AI consults gamePlayerController.gameData
                // for pool availability, and a stale read made it re-pick
                // a faction stack the engine had already emptied. The
                // pools key is absent on legacy/older payloads, so guard.
                const gamePlayerPackage = receivedMessage.package.data;
                if (gamePlayerPackage.pools) {
                    window.dispatchEvent(new CustomEvent('game-pools-event', { detail: gamePlayerPackage.pools }));
                }
                window.dispatchEvent(new CustomEvent('game-player-event', { detail: gamePlayerPackage.game_player }));
                this.processQueue();
                break;
            }
            case 'Join':
                this.joinMessage(receivedMessage);
                break;
            case 'Sit':
                this.sitMessage(receivedMessage);
                break;
            case 'Sound':
                window.dispatchEvent(new CustomEvent('sound-message-event', { detail: receivedMessage }));
                break;
            case 'Event':
                window.dispatchEvent(new CustomEvent('event-event', { detail: receivedMessage }));
                break;
            case 'Library':
                window.dispatchEvent(new CustomEvent('library-event', { detail: receivedMessage }));
                break;
            case 'Transcript':
                window.dispatchEvent(new CustomEvent('transcript-message-event', { detail: receivedMessage }));
                break;
            case 'Friend':
                this.friendMessage(receivedMessage);
                break;
            case 'Group':
                window.dispatchEvent(
                    new CustomEvent('group-event', { detail: receivedMessage }));
                break;
            case 'FromPlatformChanged':
                // CC_DISCORD_LOBBY_LIFECYCLE §5: a lobby bound to this
                // Discord channel changed (seat join/leave, launch,
                // delete). Fan out so DiscordProvider re-fetches the
                // "live in this channel" list. Payload carries only the
                // channel id; the fresh state comes from the re-GET.
                window.dispatchEvent(
                    new CustomEvent('from-platform-changed', {
                        detail: (receivedMessage.package
                            && receivedMessage.package.data) || {},
                    }));
                break;
            case 'Profile':
                this.profileMessage(receivedMessage);
                break;
            case 'Patch':
                window.dispatchEvent(new CustomEvent('patch-event', { detail: receivedMessage }));
                break;
            case 'Connection':
                window.dispatchEvent(
                    new CustomEvent('connection-event',
                        { detail: receivedMessage.connection }));
                break;
            case 'Control':
                window.dispatchEvent(
                    new CustomEvent('control-event',
                        { detail: receivedMessage }));
                break;
            case 'FTUE_STEP':
                // Scripted FTUE step. Forward the flat package to the
                // active scene runner; it delegates the toast/spotlight
                // to FtueController.setMessage. No-op if no runner is
                // mounted (e.g. outside a game view).
                this.app.ftueSceneRunner
                    && this.app.ftueSceneRunner.playStep(
                        receivedMessage.package);
                break;
            case 'Reject':
                // Typed engine rejection — well-formed click the engine
                // can't honor because state moved between send and receive.
                // Unwrap the OutgoingMessage envelope and fan the INNER
                // RejectWire dict out as event.detail, the same way the
                // other cases here dispatch receivedMessage.package.* rather
                // than the whole envelope. The hsh:reject-message detail IS
                // the flat RejectWire produced by RejectMessage.to_wire()
                // (engine/controls/rejection/reject_message.py): type,
                // handler, reason_code, reason_text, submitted,
                // current_state, valid_options, game, game_player,
                // status_id, debug. InsightsWindow listens and renders the
                // correction. The window event IS the breadcrumb — no
                // default console log.
                window.dispatchEvent(new CustomEvent(REJECT_MESSAGE_EVENT, {
                    detail: receivedMessage.package,
                }));
                break;
            case 'Error':
                console.error(receivedMessage.package.message);
                break;
            default:
                break;
        }
        // console.log(`PackageRouter.process END ^^${trackingId}^^`, this.messageQueue.map(({ type }) => type));
    }

    /**
     * There is only one List receivedMessage at the moment. List available games.
     * @param receivedMessage
     */
    listMessage = (receivedMessage) => {
        // CC_SAVED_GAMES_LIST (2026-05-27): fan the games-list payload
        // out as a window CustomEvent so the new <SavedGamesModal>
        // can react without having to reach into the legacy
        // ExistingGamesMenu component. The legacy forward stays in
        // place (no blind deletes) -- both consumers are valid.
        const data = (receivedMessage.package
            && receivedMessage.package.data) || {};
        window.dispatchEvent(new CustomEvent('list-update-event',
            { detail: data }));
        if (this.app.existingGamesMenu) {
            this.app.existingGamesMenu.receiveMessage(receivedMessage);
        } else {
            console.log('Missing existingGamesMenu');
        }
    }

    gameMessage = (receivedMessage) => {
        const gameData = receivedMessage.package.data.game;
        window.dispatchEvent(new CustomEvent('game-event', { detail: gameData }));
    }

    joinMessage = (receivedMessage) => {
        console.log('JOIN MESSAGE')
    }

    sitMessage = (receivedMessage) => {
        window.dispatchEvent(new CustomEvent(
            'game-event', { detail: receivedMessage.package.data.game }));
        window.dispatchEvent(
            new CustomEvent('game-player-sit-event',
                { detail: receivedMessage.package.data.game_player }));
    }

    friendMessage = (receivedMessage) => {
        if (receivedMessage.package.type === 'Find') {
            this.app.friendsMenu &&
                this.app.friendsMenu.receiveFindResults(receivedMessage);
            return;
        }
        this.app.friendsMenu && this.app.friendsMenu.receiveFriends(receivedMessage);
    }

    profileMessage = (receivedMessage) => {
        this.app.playerProfile && this.app.playerProfile.receiveProfile(receivedMessage);
    }
}
